/* FRENZEL persistent newsletter tab */
(function(){
  var drawer = document.getElementById('fzNewsDrawer');
  if(!drawer) return;
  var tab = document.querySelector('.fz-news-tab');
  function open(){ drawer.classList.add('fz-open'); drawer.setAttribute('aria-hidden','false'); }
  function close(){ drawer.classList.remove('fz-open'); drawer.setAttribute('aria-hidden','true'); }
  if(tab) tab.addEventListener('click', open);
  drawer.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  // focus the email field when opened via tab
  if(tab) tab.addEventListener('click', function(){ var i=drawer.querySelector('input[type=email]'); if(i) setTimeout(function(){ i.focus(); }, 500); });
})();

/* Make homepage range cards real, crawlable product links (without touching the section) */
(function(){
  var map = {
    'FRENZELGRONI': '/products/frenzelgroni-05l-flasche',
    'Clear Margarita': '/products/clear-frenzel-margarita-05l-flasche',
    'Margarita': '/products/clear-frenzel-margarita-05l-flasche',
    'Kennenlern-Paket': '/products/frenzel-kennenlern-paket-alle-3-produkte-im-set-grapefruit-likor-frenzelgroni-margarita'
  };
  document.querySelectorAll('.rcard').forEach(function(card){
    if(card.closest('a')) return;
    var h = card.querySelector('h3');
    if(!h) return;
    var text = h.textContent.trim(), url = null;
    Object.keys(map).forEach(function(k){ if(!url && text.indexOf(k) !== -1) url = map[k]; });
    if(!url) return;
    var a = document.createElement('a');
    a.href = url;
    a.setAttribute('aria-label', text + ' – Produkt ansehen');
    a.style.cssText = 'display:flex;text-decoration:none;color:inherit';
    card.parentNode.insertBefore(a, card);
    a.appendChild(card);
  });
})();
